module.exports = require("lodash.reduce");


//////////////////
// WEBPACK FOOTER
// external "lodash.reduce"
// module id = 2
// module chunks = 0